// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/menu/menu';
import 'snippets/header-menu/header-menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/cart-dropdown/cart-dropdown'; // TODO: include mini cart here for now.
import 'snippets/_containers/modal/modal';
import 'snippets/search-form/search';
import 'snippets/predictive-search/predictive-search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';

// Optional Features
import './header--sticky';
import './header-search';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var TOPLEVEL_SELECTOR = '.header--top-level';
var HAMBURGER_CLASS = 'header__link--menu';
var HAMBURGER_SELECTOR = '.header__link--menu';
var MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MENU_BUTTON_SELECTOR = '.header-menu__button';
var SEARCH_GROUP_SELECTOR = '.header__search-group';
var DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

// Classes
var OPEN_CLASS = 'js--is-open';
var NO_SCROLL_CLASS = 'noscroll';

// -------------------------------------
// Helper functions
// -------------------------------------

function syncMobileMenuHeight(menu) {
  if (menu.$header === null || menu.$hamburger === null || menu.$navWrapper === null || window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
    var _menu$$header, _menu$$header2;
    (_menu$$header = menu.$header) === null || _menu$$header === void 0 || _menu$$header.style.removeProperty('--header-mobile-menu-top');
    (_menu$$header2 = menu.$header) === null || _menu$$header2 === void 0 || _menu$$header2.style.removeProperty('--header-mobile-menu-height');
    return;
  }
  var headerTop = menu.$header.getBoundingClientRect().top;
  // The menu opens over the vehicle/search row, starting at its top edge
  var chromeBottom = menu.$searchGroup ? menu.$searchGroup.getBoundingClientRect().top : (menu.$hamburger || menu.$toplevel).getBoundingClientRect().bottom;
  var viewportBottom = window.visualViewport ? window.visualViewport.offsetTop + window.visualViewport.height : window.innerHeight;
  var menuTop = Math.max(Math.floor(chromeBottom - headerTop), 0);
  var availableHeight = Math.max(Math.floor(viewportBottom - chromeBottom), 0);
  menu.$header.style.setProperty('--header-mobile-menu-top', "".concat(menuTop, "px"));
  menu.$header.style.setProperty('--header-mobile-menu-height', "".concat(availableHeight, "px"));
}

// Open the menu
function openMenu(menu) {
  menu.$body.classList.add(NO_SCROLL_CLASS);
  menu.$header.classList.add(OPEN_CLASS);
  menu.$hamburger.classList.add(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'true');
  syncMobileMenuHeight(menu);
}

// Close the menu
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'false');
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

// Reset the Convermax garage vehicle list to the top when the dialog opens.
// .cm_garageDropdown keeps its cm_hide class even when visible inside the dialog,
// so we trigger off the click that opens it instead. We run a rAF loop for ~500ms
// so our scrollTop=0 runs before each paint and beats any deferred Convermax scroll.
(function () {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.select-vehicle__toggle')) {
      var frames = 0;
      var _tick = function tick() {
        var list = document.querySelector('#cm_GarageDialog .garage-content');
        if (list) list.scrollTop = 0;
        if (frames++ < 30) requestAnimationFrame(_tick);
      };
      requestAnimationFrame(_tick);
    }
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var _window$visualViewpor;
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $toplevel: document.querySelector(TOPLEVEL_SELECTOR),
    $searchGroup: document.querySelector(SEARCH_GROUP_SELECTOR),
    $navWrapper: document.querySelector(MENU_WRAPPER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MENU_BUTTON_SELECTOR)
  };
  if (menu.$body === null || menu.$header === null || menu.$hamburger === null) {
    return;
  }
  var updateMobileMenuHeight = function updateMobileMenuHeight() {
    if (menu.$header.classList.contains(OPEN_CLASS)) {
      syncMobileMenuHeight(menu);
    }
  };

  // Toggle the mobile menu when the hamburger is clicked
  // Otherwise, close the menu if clicked outside of it
  menu.$body.addEventListener('click', function (event) {
    var $this = event.target;
    var hamburgerClick = false;
    var hamburger = null;
    if ($this.classList.contains(HAMBURGER_CLASS)) {
      hamburgerClick = true;
      hamburger = $this;
    } else {
      var closestHamburger = $this.closest(HAMBURGER_SELECTOR);
      if (closestHamburger !== null) {
        hamburgerClick = true;
        hamburger = closestHamburger;
      }
    }
    if (hamburgerClick) {
      event.preventDefault();
      if (hamburger.classList.contains(OPEN_CLASS)) {
        closeMenu(menu);
      } else {
        openMenu(menu);
      }
    } else if ($this.closest(MENU_WRAPPER_SELECTOR) === null) {
      closeMenu(menu);
    }
  });
  window.addEventListener('resize', updateMobileMenuHeight);
  (_window$visualViewpor = window.visualViewport) === null || _window$visualViewpor === void 0 || _window$visualViewpor.addEventListener('resize', updateMobileMenuHeight);
});